var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("DynamicTp")]),_c('p',[_vm._v(" To Learn More"),_c('br'),_c('a',{attrs:{"href":"http://gaffeyl.com.cn/","target":"_blank","rel":"noopener"}},[_vm._v("这是一个可动态更改的线程池")]),_vm._v(". ")])])
}]

export { render, staticRenderFns }